module.exports = __webpack_public_path__ + "static/media/logo.07f67183.png";